/*******************************************************************************
10/19/17
Alexander Self
Royal Hawaiian Services
Preloader.js: Displays a loader to let users know there is processing occuring
*******************************************************************************/
import React from 'react';


const Preloader = () => {
  return (
    <div className="preloader-wrapper big active">
      <div className="spinner-layer spinner-blue-only">
        <div className="circle-clipper left">
          <div className="circle"></div>
        </div><div className="gap-patch">
          <div className="circle"></div>
        </div><div className="circle-clipper right">
          <div className="circle"></div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;




/* END */



// WEBPACK FOOTER //
// ./src/components/preloader.js